import {useMutation} from 'react-query';
import PostStoreRedesignView from '.';
import {toast} from 'react-toastify';
import {AxiosError} from 'axios';

interface IPostStoreRedesignViewProps {
  onSuccess?: () => void;
}
interface AxError {
  message: string;
}
const usePostStoreRedesignView = ({onSuccess}: IPostStoreRedesignViewProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IStoreLabRedesignView) => {
      return PostStoreRedesignView(payload);
    },
    onSuccess: data => {
      onSuccess && onSuccess();
    },
    onError: (data: AxiosError<AxError>) => {
      toast.error(data?.response?.data?.message || 'مشکلی پیش آمده است');
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePostStoreRedesignView};
